var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[(typeof _vm.node === 'string')?_c('p',[_vm._v(_vm._s(_vm.node))]):_vm._e(),_vm._l((_vm.node.children),function(child,index){return _c('docs-node',{key:index,attrs:{"node":child}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }